<template lang="pug" src="./custom-home-meet-doc.pug"></template>

<script>
import ImgBox from 'components/block/block-img-box/block-img-box'
import HeaderSection from 'components/block/block-header-section/block-header-section'
import { showModal } from 'components/mixins'

export default {
  props: ['props'],
  mixins: [showModal],
  components: {
    ImgBox,
    HeaderSection
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-meet-doc.vue?a06705f4